/**
 * Here live the types to extend RichTextField.
 *
 * Table: The table extension is only used internally by TableBlock. It's not
 * supported by RichText itself, meaning that a user cannot create a table when
 * interacting with RichTextField. It's also not part of the types-internal
 * RichText's types, meaning that we only use these in the frontend, so there is
 * no need to care about RichText table anywhere else.
 */

import type {
  EmbedBlock,
  ImageBlock,
  RichTextContent,
  TableContent,
  TextBlock,
} from "@prismicio/types-internal/lib/content"
import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"

export type ExtendedBlock = EmbedBlock | ImageBlock | TextBlock | TableBlock

/** Superset of RichTextContent that adds support for TableBlock. */
export interface ExtendedRichTextContent
  extends Omit<RichTextContent, "value"> {
  value: ExtendedBlock[]
}

export interface TableBlock {
  type: "table"
  content: TableContent["content"]
}

export function isTableBlock(block: ExtendedBlock): block is TableBlock {
  return block.type === "table"
}

export const ExtendedRichTextNodeType = {
  ...RichTextNodeType,
  table: "table",
} as const

export type ExtendedRichTextNodeType =
  (typeof ExtendedRichTextNodeType)[keyof typeof ExtendedRichTextNodeType]

export function isExtendedRichTextNodeTypeSet(
  set: Set<unknown> | undefined,
): set is Set<ExtendedRichTextNodeType> {
  return Boolean(set && set.has(ExtendedRichTextNodeType.table))
}
